/**
 * Industry packs: what each one switches on for a tenant. The core CRM (people, companies, inbox, deals, cases,
 * tasks, calendar) is always on; a pack adds modules on top. Selected per tenant in the Platform Console.
 *
 * Modules:
 *  - commerce: stores, product catalogue, orders, purchase history on every customer.
 *  - marketing: segments, broadcast campaigns on the consent ledger, paid-ads campaigns with spend and returns.
 *  - growth: sales opportunities (replenishment due, back-in-stock demand, lapsed customers, open enquiries).
 */
export const PACK_MODULES = ['commerce', 'marketing', 'growth'] as const;
export type PackModule = (typeof PACK_MODULES)[number];

export interface PackDef {
  key: string;
  modules: readonly PackModule[];
}

export const PACKS: Record<string, PackDef> = {
  retail: { key: 'retail', modules: ['commerce', 'marketing', 'growth'] },
  hospitality: { key: 'hospitality', modules: ['marketing'] },
  coworking: { key: 'coworking', modules: ['marketing'] },
  'electronics-trading': { key: 'electronics-trading', modules: ['commerce', 'marketing'] },
};

/** Modules enabled for a tenant's pack (none for core-only tenants). */
export function packModules(pack: string | null | undefined): readonly PackModule[] {
  return (pack && PACKS[pack]?.modules) || [];
}

export const hasModule = (pack: string | null | undefined, module: PackModule) =>
  packModules(pack).includes(module);
